import React, { useState } from "react";
import { Grid } from "semantic-ui-react";
import { emailRegex } from "../../utils/regex";
const Email = ({ getEmail, getError, wide, name, gmail }) => {
  const [email, setEmail] = useState(null);
  const handleBlur = () => {
    if (emailRegex.test(email)) {
      getEmail(email);
      getError(null);
    } else {
      getError("Not valid email");
      getEmail(null);
    }
  };
  const handleGmailBlur = () => {
    if (email.endsWith("@gmail.com")) {
      getEmail(email);
      getError(null);
    } else {
      getError("Not valid Gmail");
      getEmail(null);
    }
  };

  return (
    <Grid.Column mobile={16} tablet={wide ? 16 : 8} computer={wide ? 16 : 8}>
      <div className="form-group">
        <label htmlFor="email">
          {name} <span className="required">*</span>
        </label>
        <input
          id="email"
          type="text"
          placeholder={gmail ? "Enter Gmail" : "Enter Email"}
          autoComplete="off"
          onBlur={() => (gmail ? handleGmailBlur() : handleBlur())}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
    </Grid.Column>
  );
};

export default Email;
